Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var React = require('react');
var coreComponentsMq = require('../mq');
var coreComponentsShared = require('../shared');
var components_controls_Component = require('./components/controls/Component.js');
var components_header_Component = require('./components/header/Component.js');
var desktop_Component_desktop = require('./desktop/Component.desktop.js');
var mobile_Component_mobile = require('./mobile/Component.mobile.js');
var ResponsiveContext = require('./ResponsiveContext.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function createResponsive(desktop, mobile) {
    // eslint-disable-next-line
    function ResponsiveChild(props) {
        var _a = (React.useContext(ResponsiveContext.ResponsiveContext) || {}).view, view = _a === void 0 ? 'desktop' : _a;
        var Child = view === 'desktop' ? desktop : mobile;
        return React__default.default.createElement(Child, tslib.__assign({}, props));
    }
    return ResponsiveChild;
}
var SidePanelResponsiveComponent = React.forwardRef(function (_a, ref) {
    var children = _a.children, _b = _a.breakpoint, breakpoint = _b === void 0 ? coreComponentsShared.getComponentBreakpoint() : _b, _c = _a.size, size = _c === void 0 ? 500 : _c, defaultMatchMediaValue = _a.defaultMatchMediaValue, dataTestId = _a.dataTestId, restProps = tslib.__rest(_a, ["children", "breakpoint", "size", "defaultMatchMediaValue", "dataTestId"]);
    var query = "(min-width: ".concat(breakpoint, "px)");
    var getDefaultValue = function () { return (coreComponentsShared.isClient() ? window.matchMedia(query).matches : false); };
    var isDesktop = coreComponentsMq.useMatchMedia(query, defaultMatchMediaValue !== null && defaultMatchMediaValue !== void 0 ? defaultMatchMediaValue : getDefaultValue)[0];
    var view = isDesktop ? 'desktop' : 'mobile';
    var contextValue = React.useMemo(function () { return ({ view: view, size: size, dataTestId: dataTestId }); }, [view, size, dataTestId]);
    var Component = isDesktop ? desktop_Component_desktop.SidePanelDesktop : mobile_Component_mobile.SidePanelMobile;
    return (React__default.default.createElement(ResponsiveContext.ResponsiveContext.Provider, { value: contextValue },
        React__default.default.createElement(Component, tslib.__assign({ ref: ref, size: size, dataTestId: dataTestId }, restProps), children)));
});
var SidePanelResponsive = Object.assign(SidePanelResponsiveComponent, {
    Header: components_header_Component.Header,
    Controls: components_controls_Component.Controls,
    Content: createResponsive(desktop_Component_desktop.SidePanelDesktop.Content, mobile_Component_mobile.SidePanelMobile.Content),
    Footer: createResponsive(desktop_Component_desktop.SidePanelDesktop.Footer, mobile_Component_mobile.SidePanelMobile.Footer),
});
SidePanelResponsiveComponent.displayName = 'SidePanelResponsiveComponent';

exports.SidePanelResponsive = SidePanelResponsive;
